module.exports = function getResource(label, vars = []) {
    const resources = {
        editProfile: 'Modifier le profil',
        profileCategories: [
            'Photos et description',
            'Peau',
            'Cheveux',
            'Yeux',
            'Color IQ',
            'Date de naissance',
            'Confidentialité'
        ],
        profileCategoriesUpdated: {
            photosbio: 'Photos et description',
            beautypreferences: 'Préférences beauté',
            beautypreferencesprivacysettings: 'Paramètres de confidentialité des préférences beauté'
        }
    };
    return resources[label];
};
